import React from "react";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { getUrl } from "web/script/routing/getUrl";
import styles from "./5xx.module.css";

export default function FiveXX(): JSX.Element {
    function handleClick(): void {
        analytics.event("help center", "clicked", "500_page");
    }
    return (
        <div className={styles.wrapper}>
            <div className={styles.httpErrorLayout}>
                <h1 className={styles.bordered}>{gettext("error.500.main_heading")}</h1>
                <div className={styles.errorContent}>
                    <h2 className={styles.bordered}>{gettext("error.500.title")}</h2>
                    <p>{gettext("error.500.subtitle")}</p>
                    <a href={getUrl("helpCentreHomepage")} onClick={handleClick}>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: gettext("error.help_center_link_text"),
                            }}
                        />
                    </a>
                </div>
            </div>
        </div>
    );
}
